// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"89efcaf3","585":"8c17dc8f"}[chunkId] + ".chunk.js";
};